export var OPTION_TYPE = {
  CODE: 'code',
  TYPE: 'type',
  URL: 'url',
  PREVIEW_URL: 'thumbnailUrl'
};
//# sourceMappingURL=constant.js.map
